import { render, staticRenderFns } from "./Splitter.vue?vue&type=template&id=405978db&"
import script from "./Splitter.vue?vue&type=script&lang=js&"
export * from "./Splitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports